import commonFieldLib from './gettersCommon';

const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  deptTree: state => state.system.dept.deptTree,
  user: state => state.user.user,
  toggle: state => state.route.toggle,
  friend(state) {
    return state['im/friend']
  },
  conversation(state) {
    return state['im/conversation']
  },
  imUser(state) {
    return state['im/user']
  },
  group(state) {
    return state['im/group']
  },
  blacklist(state) {
    return state['im/blacklist']
  },


  /**
 * 当前制作的表单实体
 * @param state
 */
  model(state) {
    const m = {}
    state.builder.fields.forEach(item => {
      if (!item) return
      // 分隔线组件无值
      if (item.type !== 'divider') {
        m[item.prop] = (item.props || {}).value || item.value
      }
    })
    return m
  },
  /**
   * 通用属性表单字段配置
   * @param state
   * @return {Array|*}
   */
  commonFields(state) {
    if (!state.builder.editField) return []
    // 分隔线组件无表单字段通用属性
    if (state.builder.editField.type === 'divider') {
      return []
    }

    //  公共属性设置表单的字段集合
    let fields = [...commonFieldLib]

    // 无选项的字段，不支持字典设置
    if (!state.builder.editField.options) {
      fields = fields.filter(n => n.prop !== 'dict')
    }
    // 计算可以依赖的字段集合
    const canDependFields = state.builder.fields.filter(n => n.prop !== state.builder.editField.prop)

    // 把可依赖的字段集合构造成下拉选择框的选项
    const options = canDependFields.map(n => {
      return {
        label: n.prop,
        value: n.prop,
        type: n.type
      }
    })

    fields.push({
      label: '依赖字段',
      type: 'select',
      prop: 'depend',
      options: options,
      props: {
        clearable: true
      }
    })

    // 当前编辑的字段依赖字段名称
    const dependProp = state.builder.editField.depend
    if (dependProp) {
      // 找到依赖字段的输入框类型
      const dependType = (options.find(n => n.value === dependProp) || { type: 'text' }).type
      // 找到对应组件的参数属性集合
      const dependComponentFields = state.builder.props[dependType]
      // 从参数集合中找到value的的配置，目的是为了找到value的数据类型，根据数据类型匹配对应的输入框
      const valueField = dependComponentFields.find(n => n.prop === 'value')
      if (valueField) {
        fields.push({
          label: '依赖值',
          prop: 'dependValue',
          type: valueField.type
        })
      }

    }
    return fields
  },
  /**
   * 扩展属性表单字段配置
   * @param state
   * @return {Array|*}
   */
  extendFields(state) {
    if (!state.builder.editField) return []
    return state.builder.props[state.builder.editField.type]
  },

  /**
   * 通用属性表单实体
   * @param state
   * @param getters
   * @return {{}}
   */
  commonModel(state, getters) {
    if (!getters.commonFields) return {}
    const model = {}
    getters.commonFields.forEach(item => {
      model[item.prop] = state.builder.editField[item.prop]
    })
    return model
  },

  /**
   * 计算默认值
   * @param state
   * @param getters
   * @return {{}}
   */
  defaultValue(state, getters) {
    if (!state.builder.editField) return {}
    const type = state.builder.editField.type
    const props = state.builder.props[type] || []
    const defaultValues = {}
    props.forEach(n => {
      defaultValues[n.prop] = n.value
    })
    return defaultValues
  },

  /**
   * 扩展属性表单实体
   * @param state
   * @param getters
   * @return {{}}
   */
  extendModel(state, getters) {
    if (!getters.extendFields) return {}
    const model = {}

    getters.extendFields.forEach(item => {
      const value = state.builder.editField.props[item.prop]
      model[item.prop] = typeof value === 'undefined' ? getters.defaultValue[item.prop] : value
    })
    return model
  }
}
export default getters
